import { FC } from "react";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { MultiselectTemplate, TemplateWrapper } from "@ryde/controls";
import type {
  IBackupCreateDrawerProps,
  IInjectedDrawerProps,
} from "@ryde/shared";

import { CommonDefaultDrawer } from "../common-default-drawer";
import {
  BaseDrawer,
  DrawerFormWrapperStyled,
  DrawerHeader,
  FormFooter,
} from "../drawer";
import { BackupCreateForm } from "./backup-create-drawer.models";
import { useBackupCreateDrawer } from "./use-backup-create-drawer";

export const BackupCreateDrawer: FC<
  IBackupCreateDrawerProps & IInjectedDrawerProps
> = ({ onCloseDrawer }) => {
  const { t } = useTranslation();
  const {
    methods,
    scopeItems,
    entityItems,
    isLoadingOptions,
    isStarting,
    isStartDisabled,
    onStartClick,
  } = useBackupCreateDrawer();

  return (
    <BaseDrawer onCloseDrawer={onCloseDrawer}>
      <CommonDefaultDrawer
        className="drawer-form"
        onCloseDrawer={onCloseDrawer}
        Header={
          <DrawerHeader
            title={t("backup.create.drawerTitle")}
            onCloseDrawer={onCloseDrawer}
          />
        }
        Footer={
          <FormFooter
            cancelLabel={t("general.CLOSE")}
            onCancelClick={onCloseDrawer}
            onSaveClick={onStartClick}
            saveLabel={
              isStarting
                ? t("backup.create.inProgress")
                : t("backup.create.start")
            }
            isSaveDisabled={isStartDisabled}
          />
        }
      >
        <FormProvider {...methods}>
          <DrawerFormWrapperStyled>
            <TemplateWrapper>
              <MultiselectTemplate
                name={BackupCreateForm.scopes}
                formLabel={t("backup.create.companies")}
                formAttributes={{
                  selectItems: scopeItems,
                  disabled: isLoadingOptions,
                  skipDropdownItemsTranslation: true,
                }}
              />
            </TemplateWrapper>
            <TemplateWrapper>
              <MultiselectTemplate
                name={BackupCreateForm.entityNames}
                formLabel={t("backup.create.entities")}
                formAttributes={{
                  selectItems: entityItems,
                  disabled: isLoadingOptions,
                  skipDropdownItemsTranslation: true,
                }}
              />
            </TemplateWrapper>
          </DrawerFormWrapperStyled>
        </FormProvider>
      </CommonDefaultDrawer>
    </BaseDrawer>
  );
};
